import { render, staticRenderFns } from "./addPrescription.vue?vue&type=template&id=19a7bdd6&scoped=true"
import script from "./addPrescription.vue?vue&type=script&lang=js"
export * from "./addPrescription.vue?vue&type=script&lang=js"
import style0 from "./addPrescription.vue?vue&type=style&index=0&id=19a7bdd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a7bdd6",
  null
  
)

export default component.exports